<template>
  <div class="p-2 grid grid-cols-2 md:grid-cols-4 gap-2">
    <div class="bg-gray-200 border shadow-sm rounded hover:border-gray-600" v-for='(video,i) in videos' :key='video.url + "-" + i'>
      <pbc-video :video='video' @select="onSelect" />
    </div>
  </div>
</template>
<script>
import PbcVideo from '@ui/atoms/PbcVideo.vue';
export default {
  props: {
    videos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      preview: false
    }
  },
  components:{
    PbcVideo
  },
  methods: {
    onSelect(video) {
      console.log('vid onselect', video);
      this.$emit('select', video);
    },
  }
}
</script>
